import styles from "../../styles/toggle.module.scss";

export const Toggle = ({ active, onChange }) => {
  return (
    <div className={styles.toggleContainer} onClick={() => onChange(!active)}>
      <div
        className={`${styles.toggleControl} ${
          active ? styles.toggleOn : styles.toggleOff
        }`}
      >
        <span className={styles.toggleLabel}>
          <span>{active ? "Ativado" : "Desativado"}</span>
        </span>
      </div>
    </div>
  );
};
